// Код из этого файла загружается на каждую страницу сайта

$w.onReady(function () {
$w("#readMoreButton1").onClick(() => {
$w("#readMoreStatebox1").changeState("expandedState2");
});

$w("#readLessButton1").onClick(() => {
$w("#readMoreStatebox1").changeState("collapsedState1");
});
});
$w.onReady(function () {
	 $w("#readMoreButton").onClick(() => {
        $w("#readMoreStatebox").changeState("expandedState");
    });

    $w("#readLessButton").onClick(() => {
        $w("#readMoreStatebox").changeState("collapsedState");
    });
});